import React from 'react';
import {Element, TooltipContainer, TooltipTitle, TooltipValue} from './ProjectScopingTotals_styled';
import {useProjectTotals} from './ProjectScopingTotalsContext';
import {useIntl} from 'react-intl';

/**
 * Creating Time entries tooltip content
 * @returns JSX element with tooltip content
 */
export const ProjectScopingTotalsTooltips = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_actual_revenue_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.totalPriceAtCompletionForTasks}</TooltipValue>
			</Element>
			<Element split>
				<TooltipTitle>
					{intl.formatMessage({id: 'project_scoping.tooltip_actual_revenue_on_project'}) + ':'}
				</TooltipTitle>
				<TooltipValue>{totalsData.totalPriceAtCompletionForProject}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};

/**
 * Creating Actual Revenue tooltip content
 * @returns JSX element with tooltip content
 */
export const TimeEntriesValueTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.timeEntriesOnTasks}</TooltipValue>
			</Element>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_project'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.timeEntriesOnProject}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};

/**
 * Creating Remaining tooltip content
 * @returns JSX element with tooltip content
 */
export const RemainingValueTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_remaining_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.remainingOnTasks}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};

/**
 * Creating Estimate tooltip content
 * @returns JSX element with tooltip content
 */
export const EstimateValueTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_estimate_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.estimateOnTasks}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};

/**
 * Creating Variance tooltip content
 * @returns JSX element with tooltip content
 */
export const VarianceValueTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_variance_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.varianceOnTasks}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};
